import * as React from "react"
import styled from "styled-components"
import iso from "../../../images/iso_security_compliance.png"
import isonew from "../../../images/security_compliance_updated.png"
import soc from "../../../images/security_compliance_soc.png"
import { Container } from "react-bootstrap"

const StyledHeroContainer = styled(Container)`
.HDIW-main{
    display:flex;
    justify-content:space-between;
    
}

.maillink{
 text-decoration:underline;
}

.HDIW-para{
    text-align:justify;
}
.HDIW-image{
    width: 330px!important;
    height: 330px !important;
    
}
@media only screen and (max-width: 600px) {
.HDIW-main{
    display:block;
    
}
.HDIW-image{
    width: 230px!important;
    height: 230px !important;
    
}
}
`

const SecurityComplianceCertificate = () => {
    return (
        <StyledHeroContainer>
            <div className="py-2 HDIW-main">

                <div className="col-sm-4 text-center">
                    <img src={iso} className="HDIW-image " alt="iso certification"></img>
                </div>
                <div className="col-sm-7 py-4">
                    <h2 className="fw-bold pb-3">ISO Certification: A Mark of Quality and Reliability</h2>
                    <p className="HDIW-para">Clearout renewed its ISO 27001:2022 certification on January 23, 2026, following a thorough assessment of our information security management system. Our certification demonstrates our commitment to the highest standards for establishing, implementing, maintaining, and improving the security of important digital assets.</p>
                    <p>The ISO 27001:2022 standard is the benchmark for information security management and our certification signifies our ability to provide a secure and reliable service to our clients. Customers can trust that their data is protected when using Clearout.</p>
                    <p>To learn more about our ISO 27001:2022 certification, please reach out to us via email at <a href="mailto:us@clearout.io" className="maillink">us@clearout.io</a>.</p>
                </div>
            </div>
            <div className="py-2 HDIW-main">

                <div className="col-sm-4 text-center">
                    <img src={soc} className="HDIW-image " alt="soc certification"></img>
                </div>
                <div className="col-sm-7 py-4">
                    <h2 className="fw-bold pb-3">SOC 2 Type II Certification</h2>
                    <p className="HDIW-para">Clearout renewed its SOC 2 Type II certification on March 19, 2026, confirming adherence to the highest data security and privacy standards established by the American Institute of Certified Public Accountants' Trust Services Criteria. External auditors evaluated Clearout's internal controls to ensure customers' data meets strict criteria for security, availability, processing integrity, confidentiality, and privacy.</p>
                    <p>Our SOC 2 Type II compliance reflects our commitment to providing secure and reliable services, and the certification underscores our dedication to upholding the highest industry standards.</p>
                </div>
            </div>
            <div className="py-2 mt-2 HDIW-main">

                <div className="col-sm-4 text-center">
                    <img src={isonew} className="HDIW-image " alt="soc certification"></img>
                </div>
                <div className="col-sm-7 py-4">
                    <h2 className="fw-bold pb-3">ISO 27701 Certification: A Mark of Privacy and Trust</h2>
                    <p className="HDIW-para">Clearout is certified under ISO 27701:2019, demonstrating our strong commitment to protecting personal data and managing privacy across our systems and services.</p>
                    <p>This certification confirms that our privacy information management system (PIMS) follows globally recognized standards and best practices for handling personally identifiable information (PII).</p>
                    <p>Customers can trust that their data is collected, processed, and stored securely when using Clearout.</p>
                    <p>For more details about our ISO 27701:2019 certification, please contact us at <a href="mailto:us@clearout.io" className="maillink">us@clearout.io</a>.</p>
                </div>
            </div>

        </StyledHeroContainer>
    )
}

export default SecurityComplianceCertificate